import { NavigationEnd,Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ConsultasporestadoService } from '../../service/consultasporestado.service';
import { Meta, Title } from '@angular/platform-browser';
import { CifrasMensualesService } from '../../service/cifras-mensuales.service';
import { SeoService } from '../../service/seo.service';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-consultas-por-estado',
  templateUrl: './consultas-por-estado.component.html',
  styleUrls: ['./consultas-por-estado.component.css']
})
export class ConsultasPorEstadoComponent implements OnInit {
    nortes!:any[];
    centros!:any[];
    surs!:any[];
    cifra: any;
    cifras:any;
    month: any;
    year: any;
    activo: any;
    
    RouteText : any;
    tituloseo: any;
    urlcanonicaseo: any;
    imagenseo: any;
    keywordsseo: any;
    descripcionseo: any;

    constructor(
        private meta: Meta,
        private title: Title, 
        private router: Router,
        private _consultasPorEstadoService: ConsultasporestadoService,
        private _cifrasMensualesService: CifrasMensualesService,
        private _seoService: SeoService,
        private _urlcanonicaservice: UrlcanonicaService
        
    ){
        
        this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.RouteText = event;
            this.getSEO(event.url)
        });

        this.getNorte();
        this.getCentro();
        this.getSur();
    }

    go(){
        this.router.navigate(['estadisticas']);
    }

    getCifrasMensual() {
        this._cifrasMensualesService.getCifrasMensuales().subscribe((resp: any) => {
          console.log(resp)
            this.cifras = resp;
            this.cifra = this.cifras.cantidad
            this.month = resp[0].mes
            this.year = resp[0].year
            //this.month = this.cifras.mes
            //this.year = this.cifras.year
        });
    }

    getNorte() {
        this._consultasPorEstadoService.getNorte().subscribe((resp: any) => {
          console.log(resp)
          this.nortes = resp;
        });
    }

    getCentro() {
        this._consultasPorEstadoService.getCentro().subscribe((resp: any) => {
            this.centros = resp;
        });
    }

    getSur() {
        this._consultasPorEstadoService.getSur().subscribe((resp: any) => {
            this.surs = resp;
            console.log(resp)
        });
    }

    getSEO(page: string) {
      this._seoService.getSEO(page).subscribe((resp: any) => {
        console.log(resp)
        if (resp != null) {
          this.tituloseo = resp.titulo;
          this.descripcionseo = resp.descripcion;
          this.urlcanonicaseo = resp.urlcanonica;
          this.imagenseo = resp.imagen;
    
          this._urlcanonicaservice.createCanonicalLink();
          this.title.setTitle(this.tituloseo)
          this.meta.updateTag({
            name: 'description',
            content: this.descripcionseo
          })
    
          this.meta.updateTag({
            property: 'twitter:card',
            content: 'summary'
          })
          this.meta.updateTag({
            property: 'twitter:site',
            content: '@fundacionbest'
          })
          this.meta.updateTag({
            property: 'twitter:title',
            content: 'Fundación BEST'
          })
          this.meta.updateTag({
            property: 'twitter:description',
            content: this.descripcionseo
          })
          this.meta.updateTag({
            property: 'twitter:image',
            content: this.imagenseo
          })
    
          this.meta.updateTag({
            property: 'og:url',
            content: 'https://fundacionbest.org.mx/servicios'
          })
          this.meta.updateTag({
            property: 'og:title',
            content: this.tituloseo
          })
          this.meta.updateTag({
            property: 'og:image',
            content: this.imagenseo
          })
          this.meta.updateTag({
            property: 'og:description',
            content: this.descripcionseo
          })
        }
    
      });
    }

    ngOnInit(): void {
        this.getCifrasMensual();
    }

}